import { useContext } from 'react'

import { ZoneContext, type ZoneContextValue } from './zone-context'

/** The console-wide zone selection. Throws outside `<ZoneProvider>`. */
export function useActiveZone(): ZoneContextValue {
  const value = useContext(ZoneContext)
  if (value === undefined) {
    throw new Error('useActiveZone must be used inside <ZoneProvider>')
  }
  return value
}
